/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import moment from 'utils/moment';
import styles from '../../../../components/DetailPageBuilder/detail.module.scss';
import Panel from '../../../../components/panel';
import Collapsible from '../../../../components/collapsible/Collapsible';
import { renderInfoForType, getCountryRegion } from '../../../../utils/helpers';
import { hostName, isLocal } from '../../../../constants';
import AttachmentDetail from '../../../forms/components/AttachmentDetail';
import Clickable from '../../../../components/clickable/Clickable';
import CustomFieldDetail from '../../../../components/customFields/CustomFieldDetail';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';

const DriverDetail = (props) => {
  const url = hostName.slice(6);
  const { installationId } = props;
  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${getCountryRegion(installationId)}${url}/public`;

  const [useDetails, setDetails] = useState({});

  const firstHeaders = [
    ['application_type', 'Application Type'],
    ['created_at', 'Date']
  ];
  const lastHeaders = [
    ['attachments', 'Attachments'],
    ['signature', 'Signature']];

  const tableHeadders = [
    ['comment', 'comment'],
    ['created_at', 'Date'],
    ['application_type', 'Application Type'],
    ['first_name', 'First name'],
    ['last_name', 'last Name'],
    ['employee_id', 'Employee ID'],
    ['email', 'Email'],
    ['phone', 'Phone'],
    ['company', 'Company'],
    ['type_of_issue', 'Type of Issue'],
    ['designation', 'Designation'],
    ['driving_lic_num', 'License Number'],
    ['lic_issue_date', 'License Issue date'],
    ['lic_exp_date', 'License Expiration Date'],
    ['type_of_lic', 'License Type'],
    ['issusing_authority', 'Issusing Authority'],
    ['dob', 'Date Of Birth'],
    ['category_of_adp', 'Category Of Adp'],
    ['permit_type', 'Permit Type'],
    ['renewal_date', 'Renewal date'],
    ['booking', 'Booking Date'],
    ['attachments', 'Attachments'],
    ['signature', 'Signature']
  ];
  useEffect(() => {
    const { driverRecord, savedOtp } = props;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: savedOtp
    };
    Axios.get(`${publicUrl}/driver_permit/get_dp/${driverRecord?.key}/${driverRecord?.airport_code}`, { headers })
      .then((res) => {
        setDetails(res.data);
      })
      .catch(() => {
        toast.error('Please try again later');
      });
  }, [props, publicUrl]);

  const dateFormate = useSelector(state => state?.auth?.profile?.portal_airport?.airport_settings?.date_format) || 'MM/DD/YYYY';

  const getRow = (headers) => {
    let defaultFieldTitles =[];
    if (useDetails && useDetails.schema?.default_fields?.default_field) {
      useDetails.schema.default_fields.default_field.forEach((field) => {
        if (!field.isDisabled) {
        defaultFieldTitles[field.id] = field.title;
        }
      });
    }
    const result = headers.map((ele) => {
      if (ele[0] === 'comment' && useDetails.comment!== null) {
        return (
          <div className={styles.infoRow} style={{ width: '100%' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || [ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {useDetails?.[ele[0]]}
            </span>
          </div>
        );
      }
      if (ele[0] === 'comment') {
        return '';
      }
      if (ele[0] === 'attachments' || ele[0]==='signature') {
        return (
          <div className={styles.infoRow} style={{ width: '100%', height: 'fit-content' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || ele[1]}
              />
            </span>
            {useDetails?.[ele[0]]?.length > 0 && (
            <div style={{ width: '550px', overflow: 'scroll hidden' }}>
              <AttachmentDetail
                attachments={useDetails?.[ele[0]]}
              />
            </div>)}
          </div>
        );
      }
      if (ele[1] !== 'comment' && ele[0] !== 'booking' && defaultFieldTitles[ele[0]]) {
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || [ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {ele[1].toLowerCase().includes('date')? useDetails?.[ele[0]]? moment(useDetails?.[ele[0]]).format(dateFormate): '': useDetails?.[ele[0]]}
              {''}
              {' '}
              {(ele[0] === 'length' || ele[0] === 'width'|| ele[0] === 'height'
                || ele[1] === 'Total parking Area Allocate' || ele[1] === 'Total parking Area Occupied') ? 'meters' : ''}
            </span>
          </div>
        );
      }
      return '';
    });
    return result;
  };

  const getCustomRow = () => {
    const result = useDetails?.schema?.schema?.fields?.map(ele => ({ ...ele, value: useDetails?.response[ele.id] }));
    const customFields = result?.map((ele) => {
      if (ele.type==='select') {
        const res=ele.values.find(el => Number(el.key)===Number(ele.value));
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {res?.value}
            </span>
          </div>
        );
      }
      if (ele.type === 'datetime' || ele.type === 'date' || ele.type === 'time' || ele.type === 'only_time') {
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {renderInfoForType(ele, ele?.value, result, true)}
            </span>
          </div>);
      }
      if (ele.type === 'multiselect') {
        let res = [];
        res = result?.find(e => e.id === ele.id);
        return (
          <div className={styles.infoRow} style={{ width: ele?.title.length > 28 && '100%' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {ele?.value && ele?.value.map(val => (
                <>
                  <i key={val}>
                    {res?.values.find(e => e.key === val)
                      && res?.values.find(e => e.key === val).value}
                  </i>
                  <br />
                </>
              ))
            }
            </span>
          </div>
        );
      }
      if (ele.type === 'header') {
        return (
          <div className={styles.infoRow} style={{ width: '100%', gridColumn: '1 / span 2' }}>
            <span className={styles.title} style={{ fontWeight: 'bold', color: 'black' }}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
          </div>
        );
      }
      return (
        <>
          {ele.type !== 'attachments' && (
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id="module.detail"
                  defaultMessage={ele?.title}
                />
              </span>
              <span className={styles.rowContent}>
                {ele?.value}
              </span>
            </div>
          )}
          {ele.type === 'attachments' && ele.value && (
            <>
              <AttachmentDetail
                noBorder
                attachments={ele.value}
                title={ele.title}
              />
            </>
          )}
        </>
      );
    });
    return customFields;
  };

  const { handleBackList } = props;

  const handleDownload = (
    <> {useDetails.certificate_url && (
      <div className={styles.downloadCert}>
        <Clickable>
          <a style={{ color: '#2f5394', textDecoration: 'none' }} href={useDetails.certificate_url} download>
            <FormattedMessage
              id="adp.driver.certificate.download"
            />
          </a>
        </Clickable>
      </div>)}
    </>
  );


  return <>

    {/* <Loading loadingStatus={Object.entries(useDetails).length === 0} /> */}
    <div className={styles.container}>
      <div
        className={styles.driverbackLink}
        role="presentation"
        onClick={() => handleBackList()}
      >
        <FormattedMessage id="workorder.settings.back" defaultMessage="Back" />
      </div>

      <Panel
        contentClasses={styles.mainPanel}
        title="module.detail"
        defaultTitle="Application Details"
        style={{ padding: '40px' }}
        display={handleDownload}
      >
        <>
          <div className={styles.requestInfo}>
            {useDetails?.schema?.schema?.ordering && (
              <div className={styles.infoTable}>
                {useDetails && getRow(firstHeaders)}
                {useDetails.schema.schema.ordering.map((orderFieldId) => {
                  if (orderFieldId === 'signature') {
                    return '';
                  }
                  return (
                  <div style={{ display: 'grid', gridTemplateColumns: '200%', borderLeft: '1px solid #E6EAEE' }}>
                    <CustomFieldDetail
                      data={{ ...useDetails }}
                      version={{ schema: { fields: [...useDetails?.schema?.default_fields?.default_field] } }}
                      orderingField={orderFieldId}
                      fields={[...useDetails?.schema?.default_fields?.default_field] || []}
                      noBorder
                    />
                    <CustomFieldDetail
                      data={{ ...useDetails.response }}
                      version={useDetails?.schema}
                      orderingField={orderFieldId}
                      fields={[...useDetails?.schema?.schema?.fields] || []}
                      noBorder
                    />
                  </div>
                  );
                })}
                {useDetails?.work_flow?.booking && (
                <div className={styles.infoRow}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id="appointment"
                      defaultMessage="Appointment"
                    />
                  </span>
                  <span className={styles.rowContent}>
                    {renderInfoForType({ type: 'datetime' }, useDetails?.work_flow?.booking?.start_ts, null, null)}
                  </span>
                </div>
                )}
                {useDetails && getRow(lastHeaders)}
              </div>
            )}
            {!useDetails?.schema?.schema?.ordering && (
              <div className={styles.infoTable}>
                {getRow(tableHeadders)}
                {getCustomRow()}
              </div>
            )}
            {useDetails?.schema?.renewal_fields?.fields?.length > 0 && useDetails?.application_type === 'Renewal'
             && <div>
                    <FormattedMessageWithClass
                      id=" "
                      defaultMessage="Extra Fields During Renewal"
                      className={styles.renewalHeading}
                    />
                    <CustomFieldDetail
                      data={useDetails.renewal_response}
                      version={useDetails.schema.renewal_fields}
                      fields={useDetails.schema.renewal_fields.fields}
                    />
                </div>
            }
          </div>
          {/* displaying suspension details */}
          {useDetails?.suspended_details?.training_status
            && (
            <div style={{ width: '90%' }}>
              <Collapsible title="Suspension Details"
                styleClasses={styles.collapsibleHeader}
                collapsibleHeight="0"
              >
                <div className={styles.stepInfo}>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.suspend_by" defaultMessage="Suspended By" />
                    <p>{useDetails?.suspended_details?.suspended_by}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.suspend_date" defaultMessage="Suspended On" />
                    <p>{renderInfoForType({ type: 'datetime' }, useDetails?.suspended_details?.created_at, null, null)}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.activated_by" defaultMessage="Activated By" />
                    <p>{useDetails?.suspended_details?.activated_by}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.reactivate_date" defaultMessage="Activated On" />
                    <p>{renderInfoForType({ type: 'datetime' }, useDetails?.suspended_details?.closed_at, null, null)}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.retaken.training" defaultMessage="Retaken Training" />
                    <p>{useDetails?.suspended_details?.no_of_reattempts}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.training.start_date" defaultMessage="Training Start Date" />
                    <p>{renderInfoForType({ type: 'datetime' }, useDetails?.suspended_details?.training_started_at, null, null)}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.training.end_date" defaultMessage="Training End Date" />
                    <p>{renderInfoForType({ type: 'datetime' }, useDetails?.suspended_details?.training_completed_at, null, null)}</p>
                  </div>
                  <div className={styles.infoHalf}>
                    <FormattedMessage id="permit.suspend.detail.training.status" defaultMessage="Training Status" />
                    <p>{useDetails?.suspended_details?.training_status}</p>
                  </div>
                </div>
              </Collapsible>
            </div>
            )
          }
        </>
      </Panel>
    </div>
         </>;
};
export default DriverDetail;
